import * as React from 'react';
import { graphql, ChildProps } from 'react-apollo';
import gql from 'graphql-tag';
import { CoreHomepageAffinities } from '../../../schemas/rql';

import HomepageBumpedListings from './homepage_bumped_listings';

type Props = ChildProps<{}, CoreHomepageAffinities.Query>;

const homePageAffinitiesQuery = gql`
  query Core_Homepage_Affinities {
    me {
      uuid
      profile {
        mpid
        topProductType
        topCategoryUuids
      }
    }
  }
`;

export const affinitiesQuery = graphql<CoreHomepageAffinities.Query, CoreHomepageAffinities.Variables>(homePageAffinitiesQuery);

export function HomepageBumpedListingsContainer(props: Props) {
  const categoryUuids = props.data.me?.profile?.topCategoryUuids?.slice(0, 5) || [];
  return (
    <>
      <HomepageBumpedListings
        loading={props.data?.loading}
        topProductSlug={props.data.me?.profile?.topProductType}
        categoryUuids={categoryUuids}
      />
    </>
  );
}

export default (affinitiesQuery(HomepageBumpedListingsContainer));



// WEBPACK FOOTER //
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/src/components/discovery/homepage/homepage_bumped_listings_container.tsx